import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

/** Content fields needed by the legacy bridge when it reads unified page and blog query data. */
export const LegacyBridgeContentFragment: GraphQLTaggedNode = graphql`
	fragment LegacyBridgeContentFragment_content on Content {
		id
		status
		subType
		type
		title
		version {
			number
		}
		space {
			id
			key
			name
			type
		}
		operations {
			operation
			targetType
		}
	}
`;
